import React, { useState } from "react";
import { Helmet } from "react-helmet";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { endOfTitle } from "../../../constants/constants";
import Filter from "../components/Filter";
import { IStatisticsFilter } from "../types";
import "../../program/pages/style.css";
import { CountryWidget } from "../components/CountryWidget";
import { EducationTypeWidget } from "../components/EducationTypeWidget";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
  },
  filterContainer: {
    position: "relative",
  },
  statisticsCardsContainer: {
    width: 806,
    display: "flex",
    gap: "24px 24px",
    flexWrap: "wrap",
  },
}));

export const StatisticsPage = () => {
  const classes = useStyles();
  const [filter, setFilter] = useState<IStatisticsFilter>(
    {} as IStatisticsFilter,
  );

  return (
    <>
      <Helmet>
        <title>Statistics{endOfTitle}</title>
      </Helmet>
      <Container maxWidth="lg" className={classes.root}>
        <div className={classes.filterContainer}>
          <Filter setFilter={setFilter} />
        </div>
        <div className={classes.statisticsCardsContainer}>
          <CountryWidget filter={filter} />
          <EducationTypeWidget filter={filter} />
        </div>
      </Container>
    </>
  );
};
